<template>
    <div class="moduleManage">
        <bread-crumb :bread-list="breadList" />
        <div class="info-wrap">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">自定义模块管理</span>
            </div>
            <div class="option-wrap">
                <el-button size="small"
                           @click="addModule()">新 增</el-button>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column
                        width="70px"
                        label="序号"
                        type="index">
                    </el-table-column>
                    <el-table-column label="模块名称">
                        <template slot-scope="scope">
                            {{scope.row.moduleName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">未上线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="关联课程数0/4">
                        <template slot-scope="scope">
                            {{scope.row.relevanceExpert}}
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime}}
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人">
                        <template slot-scope="scope">
                            {{scope.row.uploader}}
                        </template>
                    </el-table-column>
                    <el-table-column label="排序">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="moveUpModule(scope.row)"></i>
                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="moveDownModule(scope.row)"></i>
                            </div>
                            <div v-else
                                 class="status-off">
                                <i class="iconfont icon-paixushang"></i>
                                <i class="iconfont icon-paixuxia"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span @click="offModule(scope.row)"
                                  v-if="scope.row.status"
                                  class="link-btn">下线</span>
                            <span @click="onModule(scope.row)"
                                  v-else
                                  class="link-btn">上线</span>
                            <span @click="editModule(scope.row)"
                                  class="link-btn">修改名称</span>
                            <span @click="editExpert(scope.row)"
                                  class="link-btn">编辑</span>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="新增自定义模块"
                   :visible.sync="isAddShow"
                   custom-class="add-module-dialog"
                   width="400px">
            <el-form :model="addForm"
                     label-width="80px"
                     ref="addForm">
                <el-form-item label="模块名称"
                              :rules="[{ required: true, message: '请输入模块名称'}]"
                              prop="name">
                    <el-input v-model.trim="addForm.name"
                              type="text"
                              placeholder="请输入模块名称"
                              show-word-limit
                              maxlength="4"></el-input>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="submitAddForm()">提 交</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelAddForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="修改模块名称"
                   :destroy-on-close="true"
                   :visible.sync="isEditShow"
                   custom-class="add-module-dialog"
                   width="400px">
            <el-form :model="editForm"
                     label-width="80px"
                     ref="editForm">
                <el-form-item label="模块名称"
                              :rules="[{ required: true, message: '请输入模块名称'}]"
                              prop="name">
                    <el-input v-model.trim="editForm.name"
                              type="text"
                              placeholder="请输入模块名称"
                              show-word-limit
                              maxlength="4"></el-input>
                </el-form-item>
                <div class="dialog-btn-wrap">
                    <el-button size="small"
                               type="primary"
                               @click="submitEditForm()">提 交</el-button>
                    <el-button size="small"
                               type="info"
                               plain
                               @click="cancelEditForm()">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog :title="classData.moduleName"
                   :visible.sync="isClassShow"
                   width="800px"
                   custom-class="class-dialog">
            <div class="table-dialog-wrap">
                <el-table :data="classList"
                          stripe
                          style="width: 100%">
                    <el-table-column width="250px"
                                     label="课程">
                        <template slot-scope="scope">
                            <div class="image_title">
                                <el-image v-if="scope.row.pictureId"
                                          class="cover-picture"
                                          :src="'/ms-hoc-video/v1/image/download?fileName='+ scope.row.pictureId">
                                </el-image>
                                <div class="text_title">
                                    <span class="image_text">{{ scope.row.title }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="doctorName"
                                     min-width="110px"
                                     label="来源医生">
                    </el-table-column>

                    <el-table-column label="排序"
                                     min-width="90px">
                        <template slot-scope="scope">
                            <div
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="classMoveUp(scope.row)"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="classMoveDown(scope.row)"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"
                                     min-width="90px">
                        <template slot-scope="scope">
                            <popover-sure title="您确定要删除该课程吗？"
                                          @sureFunction="deleteClass(scope.row)">
                                <span slot="content"
                                      class="link-btn">删除</span>
                            </popover-sure>

                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<style lang="scss">
.add-module-dialog {
    .el-dialog__body {
        padding: 24px 20px;
    }
    .el-form-item {
        margin-bottom: 24px;
        &.is-error {
            margin-bottom: 30px;
        }
    }
    .dialog-btn-wrap {
        padding: 0 20px 0px 80px;
        text-align: left;
        .el-button {
            width: 96px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            margin-left: 12px;
            background-color: #f5f5f5;
            border-color: #dbdbdb;
            color: #666;
        }
    }
}
.class-dialog {
    .status-warp {
        line-height: 12px;
        .el-badge {
            height: 10px;
            .el-badge__content {
                width: 6px;
                height: 6px;
            }
            .el-badge__content--success {
                background: #4acfb1;
            }
            .el-badge__content--info {
                background: #cccccc;
            }
        }
        .status_text {
            margin-left: 10px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            line-height: 12px;
        }
    }
    .status-on {
        .icon-off {
            color: #ccc;
        }
        .icon-on {
            cursor: pointer;
            color: #3b8fd9;
        }
        .icon-paixuxia {
            font-size: 16px;
        }
        .icon-paixushang {
            font-size: 16px;
            margin-right: 20px;
        }
    }
    .status-off {
        .icon-paixuxia {
            font-size: 16px;
            color: #ccc;
        }
        .icon-paixushang {
            font-size: 16px;
            color: #ccc;
            margin-right: 20px;
        }
    }
    .cover-picture {
        width: 70px;
        height: 70px;
        .image-slot {
            .el-icon-picture-outline {
                font-size: 70px;
            }
        }
    }

    .image_title {
        display: flex;
        align-content: center;
        .cover-picture {
            width: 70px;
            height: 70px;
        }
        .text_title {
            margin-left: 14px;
            height: 70px;
            width: 144px;
            display: flex;
            align-items: center;
        }
        .image_text {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #333333;
            line-height: 18px;
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
    .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }
    .table-dialog-wrap {
        padding-bottom: 20px;
    }
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
}
.moduleManage {
    .option-wrap {
        .el-button--small {
            width: 86px;
        }
    }
    .status-warp {
        .el-badge {
            height: 10px;
            .el-badge__content {
                width: 6px;
                height: 6px;
            }
            .el-badge__content--success {
                background: #4acfb1;
            }
            .el-badge__content--info {
                background: #cccccc;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
    padding: 20px;
    overflow: auto;
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.option-wrap {
    margin-bottom: 20px;
}
.table-wrap {
    .table-none {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .icon {
            font-size: 100px;
        }
        span {
            line-height: 14px;
        }
    }
    .link-btn {
        color: $a-link;
        cursor: pointer;
        font-size: 12px;
        display: inline-block;
        height: 14px;
        line-height: 14px;
        border-right: 1px solid $a-link;
        margin-right: 6px;
        padding-right: 6px;
        &:last-child {
            border-right: none;
            margin-right: 0;
            padding-right: 0;
        }
    }
}
.status-warp {
    line-height: 12px;
    .status_text {
        margin-left: 10px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
        line-height: 12px;
    }
}
.status-on {
    .icon-off {
        color: #ccc;
    }
    .icon-on {
        cursor: pointer;
        color: #3b8fd9;
    }
    .icon-paixuxia {
        font-size: 16px;
    }
    .icon-paixushang {
        font-size: 16px;
        margin-right: 20px;
    }
}
.status-off {
    .icon-paixuxia {
        font-size: 16px;
        color: #ccc;
    }
    .icon-paixushang {
        font-size: 16px;
        color: #ccc;
        margin-right: 20px;
    }
}
</style>

<script>
import { mapGetters } from 'vuex'
import popoverSure from '@/components/PopoverSure/popoverSure.vue'
export default {
    data () {
        return {
            breadList: [{ label: '运营管理' }, { label: '自定义模块管理' }],
            loading: false,
            dataList: [],
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            },
            addForm: {
                name: ''
            },
            isAddShow: false,
            editForm: {
                name: ''
            },
            isEditShow: false,
            editData: {},
            isClassShow: false,
            classData: {},
            classList: []
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    components: {
        popoverSure
    },
    methods: {
        pageChange (value) {
            this.page.current = value
            this.queryList()
        },
        addModule () {
            this.isAddShow = true
            this.$nextTick(() => {
                this.$refs['addForm'].resetFields()
            })
        },
        editModule (item) {
            this.editData = item
            this.editForm.name = this.editData.moduleName
            this.isEditShow = true
        },
        editExpert (item) {
            this.classData = item
            this.classList = JSON.parse(JSON.stringify(this.classData.expertSeminars))
            if (this.classList && this.classList.length > 0) {
                this.$set(this.classList[0], 'noMoveUp', true)
                this.$set(this.classList[this.classList.length - 1], 'noMoveDown', true)
            }
            this.isClassShow = true
        },
        async deleteClass (item) {
            const { results } = await this.$services.moduleServices.deleteExpertModule(item.expertSeminarId, this.classData.moduleId)
            if (results) {
                this.$message.success('删除成功！')
                this.queryList(() => {
                    const arr = this.dataList.find(data => data.moduleId === this.classData.moduleId).expertSeminars
                    this.classList = JSON.parse(JSON.stringify(arr))
                    if (this.classList.length > 0) {
                        this.$set(this.classList[0], 'noMoveUp', true)
                        this.$set(this.classList[this.classList.length - 1], 'noMoveDown', true)
                    }
                })
            }
        },
        async classMoveUp (item) {
            const { results } = await this.$services.moduleServices.moveUpExpertModule(item.expertSeminarId, this.classData.moduleId)
            if (results) {
                this.queryList(() => {
                    const arr = this.dataList.find(data => data.moduleId === this.classData.moduleId).expertSeminars
                    this.classList = JSON.parse(JSON.stringify(arr))
                    if (this.classList.length > 0) {
                        this.$set(this.classList[0], 'noMoveUp', true)
                        this.$set(this.classList[this.classList.length - 1], 'noMoveDown', true)
                    }
                })
            }
        },
        async classMoveDown (item) {
            const { results } = await this.$services.moduleServices.moveDownExpertModule(item.expertSeminarId, this.classData.moduleId)
            if (results) {
                this.queryList(() => {
                    const arr = this.dataList.find(data => data.moduleId === this.classData.moduleId).expertSeminars
                    this.classList = JSON.parse(JSON.stringify(arr))
                    if (this.classList.length > 0) {
                        this.$set(this.classList[0], 'noMoveUp', true)
                        this.$set(this.classList[this.classList.length - 1], 'noMoveDown', true)
                    }
                })
            }
        },
        submitEditForm () {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    this.postEditForm()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        cancelEditForm () {
            this.isEditShow = false
        },
        async postEditForm () {
            const param = {
                moduleName: this.editForm.name,
                moduleId: this.editData.moduleId
            }
            const { results } = await this.$services.moduleServices.updateModule(param)
            this.isEditShow = false
            this.page.current = 1
            this.queryList()
            if (results) {
                this.$message.success('修改成功！')
            }
        },
        async moveUpModule (item) {
            const { results } = await this.$services.moduleServices.moveUpModule(item.moduleId)
            if (results) {
                this.queryList()
            }
        },
        async moveDownModule (item) {
            const { results } = await this.$services.moduleServices.moveDownModule(item.moduleId)
            if (results) {
                this.queryList()
            }
        },
        async offModule (item) {
            this.loading = true
            const { results } = await this.$services.moduleServices.offModule(item.moduleId)
            this.queryList()
            if (results) {
                this.$message.success('下线模块成功！')
            }
        },
        async onModule (item) {
            this.loading = true
            const { results } = await this.$services.moduleServices.onModule(item.moduleId)
            this.queryList()
            if (results) {
                this.$message.success('上线模块成功！')
            }
        },
        submitAddForm () {
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.postAddForm()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async postAddForm () {
            const param = {
                moduleName: this.addForm.name,
                hospitalId: this.userInfo.hospitalId,
                priority: 0,
                status: false,
                uploader: this.userInfo.accountName
            }
            const { results } = await this.$services.moduleServices.addModule(param)
            this.isAddShow = false
            this.page.current = 1
            this.queryList()
            if (results) {
                this.$message.success('新增成功！')
            }
        },
        cancelAddForm () {
            this.isAddShow = false
        },
        async queryList (func) {
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                hospitalId: this.userInfo.hospitalId
            }
            const { results, total } = await this.$services.moduleServices.getModuleList(param)
            if (results.length > 0) {
                if (results[0].priority !== 0 && this.page.current === 1) {
                    this.$set(results[0], 'noMoveUp', true)
                }
                if (results[results.length - 1].priority === 1) {
                    this.$set(results[results.length - 1], 'noMoveDown', true)
                }
                this.dataList = results
            }
            this.page.total = total
            if (func) {
                func()
            }
            this.loading = false
        }
    },
    mounted () {
        this.queryList()
    }
}
</script>
